<script lang="ts">
	import { streamToastMessages } from "$lib/serv/toast";
	import { fly } from "svelte/transition";
	import { flip } from "svelte/animate";

	import Alert from "$lib/ui/shared/Alert.svelte";

	const toasts$ = streamToastMessages();
</script>

{#if $toasts$}

	<div class="toasts">

		{#each $toasts$ as toast (toast.id)}
			<div in:fly={{ x: -20 }} out:fly={{ x: 20 }} animate:flip={{ duration: 200 }}>
				<Alert alert={toast} />
			</div>
		{/each}
		
	</div>

{/if}

<style lang="scss">
	@use 'margin';

	div {
		@include margin.tiny;
	}
</style>